<template>
  <v-col cols="12">
    <div>
      <naj-box
        :no-header="hideNajBox"
        :no-gutters="hideNajBox"
        :no-margin-bottom="hideNajBox"
        :title="locales.sectionTitle"
      >
        <v-row>
          <v-col cols="4">
            <naj-input
              :type-id="formFieldType.text"
              :label="locales.socialId"
              :value.sync="formModel.socialId"
              :disabled="isChecking || (formModel.isHeirsDataRetrieved && formModel.socialId) || viewMode"
              validates="required"
              @input="socialIdChanged"
            ></naj-input>
          </v-col>
          <v-col cols="4">
            <naj-input
              :type-id="formFieldType.text"
              :label="locales.instrumentNumber"
              :value.sync="formModel.instrumentNumber"
              :disabled="isChecking || viewMode"
              validates="required"
              @input="instrumentNumberChanged"
            ></naj-input>
          </v-col>
          <v-col
            cols="4"
            align-self="center"
            class="text-right"
          >
            <naj-button
              v-if="isCheckButtonVisible"
              square
              :loading="isChecking"
              :disabled="isCheckButtonDisabled || viewMode"
              @click="check"
            >
              {{ local.personInformation.check }}
            </naj-button>
          </v-col>
        </v-row>
      </naj-box>
    </div>

    <div>
      <naj-box
        ref="deceasedSection"
        :no-header="hideNajBox"
        :no-gutters="hideNajBox"
        :no-margin-bottom="hideNajBox"
        :title="locales.deceasedSectionTitle"
      >
        <v-row>
          <v-col cols="4">
            <naj-input
              :type-id="formFieldType.text"
              :label="locales.deceasedNameLabel"
              :value.sync="formModel.deceasedFullName"
              :disabled="viewMode"
              validates="required"
            ></naj-input>
          </v-col>
          <v-col cols="4">
            <naj-input
              :type-id="formFieldType.date"
              :label="locales.deceasedDeathDateLabel"
              :value.sync="formModel.deceasedDeathDate"
              :disabled="viewMode"
              validates="required"
            ></naj-input>
          </v-col>
          <v-col cols="4">
            <naj-input
              :type-id="formFieldType.radioButton"
              :label="locales.deceasedGenderLabel"
              :value.sync="formModel.deceasedGender"
              :items="sex"
              :disabled="viewMode"
              item-value="id"
              item-text="name"
              validates="required"
            ></naj-input>
          </v-col>
        </v-row>
      </naj-box>
    </div>

    <heirs-grid
      :form-model="formModel"
      :root-form-model="rootFormModel"
      :view-mode="viewMode"
    ></heirs-grid>
  </v-col>
</template>

<script>
import HeirsGrid from './heirs-grid';
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapGlobalActions } = createNamespacedHelpers(
  'GlobalModule'
);
const { mapState: mapLUTState } = createNamespacedHelpers('LookupsModule');
export default {
  name: 'CheckHeirsData',
  components: { HeirsGrid },
  props: {
    formModel: {
      type: Object,
      required: true,
    },
    rootFormModel: {
      type: Object,
      required: true,
    },
    hideNajBox: {
      type: Boolean,
      required: false,
    },
    viewMode: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      isChecking: false,
      isManual: false,
    };
  },
  computed: {
    ...mapLUTState(['sex']),
    locales() {
      return this.local.dynamicFormAdmin.customComponents.checkHeirsData;
    },
    isCheckButtonDisabled() {
      return (
        !this.formModel.socialId ||
        !this.formModel.instrumentNumber ||
        this.isChecking
      );
    },
    isCheckButtonVisible() {
      return !this.formModel.isHeirsDataRetrieved || this.isChecking;
    },
    isFieldDisabled() {
      return this.isManual || this.isChecking;
    },
  },
  methods: {
    ...mapGlobalActions(['getDeceasedAndHeirsData']),
    check() {
      this.isChecking = true;
      this.resetForm();
      this.getDeceasedAndHeirsData({
        requestCode: this.formModel.instrumentNumber,
        socialId: this.formModel.socialId,
      })
        .then((res) => {
          if (res.data) {
            this.$set(this.formModel, 'isHeirsDataRetrieved', true);
            this.toaster.success(this.local.common.verificationSucceeded);
            const mappedData = {
              deceasedFullName: res.data.deceased.fullName,
              deceasedDeathDate: res.data.deceased.deathDate,
              deceasedGender: res.data.deceased.genderId,
              socialId: res.data.deceased.socialId,
              heirsData: this.mapHeirsData(res.data.allHeirs),
            };
            Object.keys(mappedData)
              .map((key) => {
                this.$set(this.formModel, key, mappedData[key]);
                return key;
              });
          }
        })
        .catch(() => {
          this.isManual = true;
          this.toaster.error(this.local.common.noData);
        })
        .finally(() => {
          this.isChecking = false;
        });
    },
    resetForm() {
      if (this.formModel.isHeirsDataRetrieved) {
        this.$set(this.formModel, 'heirsData', null);
        this.$set(this.formModel, 'deceasedGender', null);
        this.$set(this.formModel, 'deceasedDeathDate', null);
        this.$set(this.formModel, 'deceasedFullName', null);
        this.$refs.deceasedSection.$validator.reset();
      }
      this.$set(this.formModel, 'isHeirsDataRetrieved', false);
      this.isManual = false;
    },
    instrumentNumberChanged() {
      this.resetForm();
    },
    socialIdChanged() {
      this.resetForm();
    },
    mapHeirsData(apiData) {
      // const heirsData = this.formModel.heirsData;
      // if(heirsData && heirsData.length){
      //   for(index in heirsData){

      //   }
      // }
      return apiData.map(item => ({
        heirGender: item.genderId,
        heirGenderName: item.gender,
        deceasedRelationship: item.relationToDeceasedName,
        heirName: item.fullName,
        idNumber: item.socialId,
        birthDate: item.dateOfBirth,
        heirCondition: item.statusId,
        heirConditionName: item.statusName,
        issuerSubGrid: null,
        instrumentNumberSubGrid: null,
        dateSubGrid: null,
        heirsSubGrid: null,
        objectKey: item.personId,
      }));
    },
  },
};
</script>

<style lang="scss" scoped>
</style>